export default __webpack_public_path__ + "static/media/pin.6ef6bec1.svg";